/**
 * Portal Manta · Dados
 * Extraído de portal_manta_v28_12.jsx
 * v29 modular · 2026-05-11
 */

export const UFS_BR = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'];
